<template>
  <div>
    <el-row :gutter="24">
      <el-col :span="!isMobile ? 12 : 24">
        <p><b>СРТС автомобиля</b></p>
        <el-form-item>
          <upload-document-modal
            ref="uploadDocumentModal"
            name-document="СРТС"
            :data-edit="dataForEdit"
            :object-data="objectData"
            :source-id="dataForEdit.sourceId"
            :need-additional="false"
            :advanced-info="advanceInfoData"
            @savedAdvanced="savedAdvanced"
          />
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { filesValidateMixinChildActions } from '@/mixins/filesValidateMixin'
import UploadDocumentModal from '../../../components/Upload/UploadDocumentModal'
import filesMixin from '../Mixins/files'

export default {
  name: 'FileSts',
  components: { UploadDocumentModal },
  mixins: [filesMixin, filesValidateMixinChildActions],
  props: {
    auto: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      advanceInfoData: {
        sts: {
          title: 'Номер СТС',
          fieldName: 'sts',
        },
        vin: {
          title: 'VIN',
          fieldName: 'vin',
        },
      },
      filesValidateMixinData: {
        refComponentName: 'uploadDocumentModal',
        errorMessage: 'СРТС автомобиля',
        childFilesCountProperty: 'countFiles',
      },
      dataForEdit: {
        sourceModelName: 'autos',
        sourceId: 0,
        documentType: 'auto_sts', // СРСТ
      },
      objectData: {},

      source_model_id: 1,
    }
  },
  methods: {
    savedAdvanced(data) {
      this.$emit('savedAdvanced', data)
    },
  },
}
</script>

<style scoped></style>
